module.exports = __webpack_public_path__ + "static/media/error.66ffdc39.png";